import React, { Fragment } from 'react';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { Button, Box, Typography, Tooltip, Switch, IconButton, FormControlLabel, TextField, InputAdornment } from "@mui/material";
import { Space, Row, Col, Image } from "antd";
import { NavLink } from "react-router-dom";
import infoMarkIcon from "../../../../../../assets/images/icon_actions/infoMark.svg";


export const InvoiceLineForm = (props) => {
    const { classes, clsx, lineForm, lineError, currencyFormat,
        productGstdetails, hsnDetails, handleEdit,
        idNamingConversion, hsnApi, handleLineSubmit, view, title, handleAddMore,
        customObject, changeHandler, handleLineIncludeGst, form } = props;

    return (
        <Box
            className={clsx(classes.customForm, classes.removeUnderline)}
            component="form"
            autoComplete='off'
            onSubmit={(e) => handleLineSubmit(e)}>
            <div className={classes.customFormFlex}>
                <Row gutter={30}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Line {lineForm?.lineNumber} Details</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productName || '---'}</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Description</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                            {lineForm?.description || '---'}
                        </Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Quantity</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                            {lineForm?.quantity || '---'}
                        </Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                            {lineForm?.unit?.name || '---'}
                        </Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <div className={classes.customUnitPrice}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit Price</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                {lineForm?.pricePerUnit || '---'}
                            </Typography>
                        </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Remaining Qty.</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                            {lineForm?.available_quantity || 0}
                        </Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Invoice Quantity</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.invoice_quantity || '---'}
                                </Typography>
                            </> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                label={["Invoice Quantity ", <span key={"Invoice Quantity"} className={classes.colorRedRequired}> *</span>]}
                                type={'number'}
                                variant={'standard'}
                                value={lineForm?.invoice_quantity || ''}
                                id={idNamingConversion('Invoice Quantity', 'salesOrderLine', 'TextField')}
                                error={lineError?.invoice_quantity}
                                helperText={lineError?.invoice_quantity}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                }}
                                inputProps={{
                                    step: "any"
                                }}
                                onWheel={(e) => e.target.blur()}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => {
                                    if (e.target.value !== '') {
                                        if (e.target.value < 0) {
                                            changeHandler(e.target.value = 0, 'invoice_quantity');
                                        } else if (e.target.value > lineForm?.duplicate_available_quantity) {
                                            changeHandler(lineForm?.duplicate_available_quantity, 'invoice_quantity');
                                        } else {
                                            changeHandler(e.target.value, 'invoice_quantity');
                                        }
                                    } else {
                                        changeHandler(e.target.value, 'invoice_quantity');
                                    }
                                }}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <div className={classes.customUnitPrice}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Invoice Unit Price</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineForm?.invoice_unitPrice || '---'}
                                    </Typography>
                                </> : <>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["Invoice Unit Price ", <span key={"Invoice Unit Price"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        id={idNamingConversion('Invoice Unit Price', 'salesOrderLine', 'TextField')}
                                        error={lineError?.invoice_unitPrice}
                                        helperText={lineError?.invoice_unitPrice}
                                        value={lineForm?.invoice_unitPrice}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                            classes: {
                                                input: classes.textFieldColor,
                                            },
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        inputProps={{
                                            step: "any"
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) =>
                                            e.target.value !== '' ?
                                                e.target.value < 0 ?
                                                    changeHandler((e.target.value = 0), 'invoice_unitPrice') : changeHandler(e.target.value, 'invoice_unitPrice') : changeHandler(e.target.value, 'invoice_unitPrice')}
                                    />
                                </>
                            }
                        </div>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Line Amount</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.amount ? '₹ ' + currencyFormat(lineForm?.amount) : '---'}</Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Line Amount</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.invoice_netAmount && lineForm?.invoice_quantity ? '₹ ' + currencyFormat(lineForm?.invoice_netAmount) : '---'}</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Discount Details</Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <> <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Discount %</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.discountPercent || '---'}
                                </Typography></> : <TextField autoComplete='one-time-code'
                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                    label='Discount %'
                                    title={'Enter discount in Percentage'}
                                    variant={'standard'}
                                    type={'number'}
                                    id={idNamingConversion('Discount', 'salesOrderLine', 'TextField')}
                                    error={lineError?.discountPercent}
                                    helperText={lineError?.discountPercent}
                                    value={lineForm?.discountPercent || ''}
                                    fullWidth
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? changeHandler((e.target.value = 0), 'discountPercent') : changeHandler(e.target.value, 'discountPercent') : changeHandler(e.target.value, 'discountPercent')}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                            <span>Calculated discount amount</span>
                            <Tooltip
                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                <IconButton>
                                    <Image src={infoMarkIcon} preview={false} />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.discountPercAmount ? '₹ ' + currencyFormat(lineForm?.discountPercAmount) : '---'}</Typography>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <><Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Discount Amount</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.discountAmount || '---'}
                                </Typography></> : <TextField autoComplete='one-time-code'
                                    className={clsx(classes.margin20t, classes.removeUnderline)}
                                    label='Discount Amount'
                                    variant={'standard'}
                                    title={'Enter discount in Amount'}
                                    type={'number'}
                                    id={idNamingConversion('Discount Amount', 'salesOrderLine', 'TextField')}
                                    error={lineError?.discountAmount}
                                    helperText={lineError?.discountAmount}
                                    value={lineForm?.discountAmount || ''}
                                    fullWidth
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    inputProps={{
                                        step: "any"
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? changeHandler((e.target.value = 0), 'discountAmount') : changeHandler(e.target.value, 'discountAmount') : changeHandler(e.target.value, 'discountAmount')}
                            />}
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                            <span>Total Discount Amount</span>
                            <Tooltip
                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                <IconButton>
                                    <Image src={infoMarkIcon} preview={false} />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.discountCalcAmount ? '₹ ' + currencyFormat(lineForm?.discountCalcAmount) : '---'}</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Row gutter={30}>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details </Typography>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Tax Invoice</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {lineForm?.includeGst ? 'Yes' : 'No'}
                                        </Typography>
                                    </> : <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')
                                        }}
                                        id={idNamingConversion('Tax Invoice', 'salesOrderLine', 'Radio')}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => handleLineIncludeGst(!lineForm.includeGst)}
                                            checked={lineForm?.includeGst}
                                        />}
                                        label="Tax Invoice"
                                        labelPlacement="top"
                                        disabled={!form?.includeGst}
                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                    />
                                }
                            </Col>
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Row gutter={30}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product GST Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {lineForm?.productGst?.code || '---'}
                                                </Typography>
                                            </> : <AutoCompleteComponent
                                                name={["Product GST Code"]}
                                                heads={[{ 'key': 'code', 'name': 'Product GST Code' },
                                                { 'key': 'percentage', 'name': 'Percentage', 'prefix': '%' }]}
                                                details={productGstdetails}
                                                id={idNamingConversion('Product GST Code', 'salesOrderLine', 'DropDown')}
                                                parentValue={customObject(productGstdetails, lineForm?.productGstId)}
                                                onChange={(data) => changeHandler(data, 'productGstId')}
                                                parentError={lineError?.productGstId}
                                                position={"top"}
                                                topPosition={true}
                                                disabled={!lineForm?.includeGst}
                                                customClasses={classes.margin20t}
                                            />
                                        }
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} disabled={!lineForm?.includeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>CGST</Typography>
                                        <Typography variant={'h6'} disabled={!lineForm?.includeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.cgstPercentage ? lineForm?.cgstPercentage + '%' : '---'} - {lineForm?.cgstPercentage ? lineForm?.cgst ? '₹ ' + currencyFormat(lineForm?.cgst) : '---' : '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>HSN Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                    {lineForm?.hsn?.hsnCode || '---'}
                                                </Typography>
                                            </> : <AutoCompleteComponent
                                                name={["HSN Code"]}
                                                heads={[{ 'key': 'hsnCode', 'name': 'HSN Code' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={hsnDetails}
                                                id={idNamingConversion('HSN Code', 'salesOrderLine', 'DropDown')}
                                                parentError={lineError?.hsnId}
                                                parentValue={customObject(hsnDetails, lineForm?.hsnId)}
                                                onChange={(data) => changeHandler(data, 'hsnId')}
                                                position={"top"}
                                                searchType={(s) => hsnApi(s)}
                                                disabled={!lineForm?.includeGst}
                                                topPosition={true}
                                                customClasses={classes.margin20t}
                                            />
                                        }
                                    </Col>
                                    {console.log(lineForm)}
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} disabled={!lineForm?.includeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>SGST / UTGST</Typography>
                                        <Typography variant={'h6'} disabled={!lineForm?.includeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.sgstPercentage ? lineForm?.sgstPercentage + '%' : '---'} - {lineForm?.sgstPercentage ? lineForm?.sgst ? '₹ ' + currencyFormat(lineForm?.sgst) : '---' : '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} disabled={!lineForm?.includeGst}
                                            className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                            <span>GST Amount </span>
                                            <span><Tooltip
                                                classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                title={'Rounded to 2 decimal places'} arrow placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                <IconButton>
                                                    <Image src={infoMarkIcon} preview={false} />
                                                </IconButton>
                                            </Tooltip></span>
                                        </Typography>
                                        <Typography variant={'h6'} disabled={!lineForm?.includeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.gstAmount ? '₹ ' + currencyFormat(lineForm?.gstAmount) : '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} disabled={!lineForm?.includeGst} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>IGST</Typography>
                                        <Typography variant={'h6'} disabled={!lineForm?.includeGst} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.igstPercentage ? lineForm?.igstPercentage + '%' : '---'} - {lineForm?.igstPercentage ? lineForm?.igst ? '₹ ' + currencyFormat(lineForm?.igst) : '---' : '---'}</Typography>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center" size={[10, 10]}>
                    {
                        lineForm?.duplicate_available_quantity > 0 && <>
                            {
                                view ? <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink> :
                                    <>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn)}>
                                            {
                                                title === 'Edit' ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            title === 'Add' && <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn)}
                                                onClick={(e) => handleAddMore(e)}
                                            >Add More</Button>
                                        }
                                    </>
                            }
                        </>
                    }

                </Space>
            </div>
        </Box>
    )
}